import logger from '../log';
import racedFetch from '../common/utils/racedFetch';
import { PingData, probeUrlList } from './probeUrls';
import { ContentCallInfo, getProbeUrlsUrl } from '../common/utils/contentUrls';

const log = logger.getLogger(__filename);

export const onProbeUrlResolve = async (
  response: Response,
  previousProbe?: PingData
): Promise<PingData> => {
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  const urls = await response.json();
  if (!(urls instanceof Array)) {
    log.warn('Unexpected data', urls);
    throw new Error('unexpected data returned');
  }
  return probeUrlList(urls, previousProbe);
};

export const onProbeUrlReject = async (
  e: Error,
  previousProbe?: PingData
): Promise<PingData> => {
  log.debug('unable to get ping data', e);
  if (previousProbe) {
    return previousProbe;
  }
  return { hasProbed: false, probeUrls: [] };
};

/**
 * Get Locality information from /content/<contentId>/tenant/<tenantId>/probeurls
 *
 * @param info - the information to make a call to the content service to get probeurls
 *
 * Always returns a PingData
 */
const getLocalityPingData = async (
  info: ContentCallInfo,
  previousProbe?: PingData
): Promise<PingData> => {
  try {
    const url = getProbeUrlsUrl(info);
    const options = {};
    try {
      const r = await racedFetch({ url, options, timeout: 200, retries: 0 });
      return onProbeUrlResolve(r, previousProbe);
    } catch (e) {
      return onProbeUrlReject(e as Error, previousProbe);
    }
  } catch (e) {
    return previousProbe || { hasProbed: false, probeUrls: [] };
  }
};

export default getLocalityPingData;
